import React, { useEffect } from "react";
import { Stack } from "@mui/material";

import { useGetAllJobData } from "../../hooks";
import { HubTableTemplate } from "../../components";

import { items, keys } from "./helper";

const OrdersWorkOrder = ({ defaultLocation, per, startDate, endDate }) => {
  const query = { defaultLocation, per, start: startDate, end: endDate };
  const { data, isLoading } = useGetAllJobData(query);

  const headerProps = {
    items,
  };
  const bodyProps = {
    items: data?.orders,
    keys,
  };
  const props = {
    headerProps,
    bodyProps,
    meta: data?.meta,
    isLoading,
  };

  return (
    <Stack gap="10px" overflow="hidden">
      <HubTableTemplate id="LineItemsTable" {...props} />
    </Stack>
  );
};

export const OrdersWorkOrderTable = OrdersWorkOrder;
